import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from "@mui/material";
import ClearIcon from '@mui/icons-material/Clear';

import { useNavigate } from 'react-router-dom';
import { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import styles from '../styles/components/concours.module.scss'; 

export default function ConcoursSentPopup ({ isVisible, setIsVisible }) {

    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    
    const onCancelClick = () => {
        navigate('/');
    }   


    const emojis = ["🎉", "🏆", "🎁", "⭐"];

    return(

      <div className={classNames(styles.dialogContainer, isVisible? styles.dialogOpen: styles.dialogClosed)}>
      
        <div className={styles.emojiBg}>
          {Array.from({ length: 20 }).map((_, i) => (
            <span
              key={i}
              className={styles.emoji}
              style={{
                top: `${Math.random() * 100}%`,
                left: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 5}s`,
                animationDuration: `${6 + Math.random() * 6}s`,
                fontSize: `${14 + Math.random() * 20}px`,
              }}
            >
              {emojis[Math.floor(Math.random() * emojis.length)]}
            </span>
          ))}
        </div>
        <div className={styles.dialogContent}>
          {/* <div className={styles.closeBtnContainer}>
            <button className={styles.closeBtn} 
            onClick={()=>{setIsVisible(false); navigate("/")}}>
                <ClearIcon sx={{color: "gray",
                    fontSize:"20px",
                    "&:hover": {
                        color: "black",
                    }
                }}/>
            </button>
          </div> */}
            <div className={styles.iconWrapper}>
                <span className={styles.icon}>🎉</span>
            </div>
            <div className={styles.dialogTextWrapper}>

              <p className={styles.dialogText}>{t('participationConfirmed')}</p>
              <h2 className={styles.dialogHeader}
              onClick={()=>{setIsVisible(false); navigate("/")}}>{t('goodLuck')}</h2>
            </div>
        </div>
    </div>
    )
}
